import classNames from "classnames";
import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import { RatingViewModel } from "Services/API/API";
import { Card, CardProps } from "Components/Card";
import { Rating } from "Components/Rating";
import moment from "moment";

interface ReviewProps extends CardProps {
   className?: string;
   review: RatingViewModel;
}
export const Review: React.FC<ReviewProps> = ({ className, review, ...rest }) => {

   const reviewRef = useRef<HTMLDivElement>(null);

   const [readMoreVisible, setReadMoreVisible] = useState(false);
   const [isLineTrimmed, setIsLineTrimmed] = useState(true);

   const showOrHideMore = () => {
      if (reviewRef?.current && reviewRef.current.offsetHeight < reviewRef.current.scrollHeight) {
         setReadMoreVisible(true);
      }
   }

   const onClickReadMoreHandler = (e: SyntheticEvent) => {
      e.preventDefault();
      setReadMoreVisible(false);
      setIsLineTrimmed(false);
   }

   useEffect(() => {
      showOrHideMore();
      window.addEventListener("resize", showOrHideMore);

      return function cleanup() {
         window.removeEventListener("resize", showOrHideMore);
      }
   }, []);

   return (
      <Card className={classNames("review", className)} {...rest}>
         <div className="review-header">
            <div className="d-flex text-truncate">
               <div className="review-user-image" style={{ backgroundImage: `url(${review.memberPicture})` }}></div>
               <div className="flex-grow mx-px16 text-truncate">
                  <div className="h8 mb-px4 text-truncate">{review.memberFullName}</div>
                  <div className="lbl1 tc-secondary text-truncate">{review.memberTitle}</div>
               </div>
            </div>
            <div className="text-right rating pt-px16 pt-sm-0">
               <Rating className="mb-0 mb-sm-px8" stars={review.stars} hideNumber />
               <div className="lbl1 tc-secondary">{moment(review.date).format("MM/DD/YYYY")}</div>
            </div>
         </div>
         <div className="review-body">
            <div className={`review-content ${isLineTrimmed ? "trim-line-2" : ""}`} ref={reviewRef}>
               {review.reviewText}
            </div>
            <div className={classNames("review-read-more", { "d-none": !readMoreVisible })}>
               <a href="#" onClick={onClickReadMoreHandler}>Read more...</a>
            </div>
         </div>
         <a className="review-workspace" href={review.workspaceUrl} target="_blank">
            <div className="review-workspace-img" style={{ backgroundImage: `url(${review.workspacePicture})` }}></div>
            <div className="text-truncate">
               <div className="h8 text-truncate" title={`${review.workspaceName} @ ${review.venueName}`}>{review.workspaceName} @ {review.venueName}</div>
               <div className="lbl1 tc-secondary text-truncate" title={review.venueAddress}>{review.venueAddress}</div>
            </div>
         </a>
      </Card>
   );
}